import React, { useEffect, useState } from 'react'
import { AppLayout } from '../../components/layout/AppLayout'
import { apiFetch } from '../../lib/api-client'

interface LedgerEntry {
  id: string
  entry_date: string
  account_no: string
  account_name: string
  description: string | null
  invoice_number: string | null
  afdeling: string | null
  debit_oere: number
  credit_oere: number
}

function kr(oere: number): string {
  if (!oere) return '—'
  return (oere / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.'
}

const th: React.CSSProperties = { padding: '11px 20px', fontSize: 11, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em', textAlign: 'left', borderBottom: '1px solid #e8eaed' }
const td: React.CSSProperties = { padding: '11px 20px', fontSize: 13, color: '#111827', borderTop: '1px solid #f3f4f6' }
const num: React.CSSProperties = { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }

export function PosteringerPage() {
  const [entries, setEntries] = useState<LedgerEntry[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    apiFetch<LedgerEntry[]>('/api/v1/ledger/entries').then(setEntries).catch(() => {}).finally(() => setLoading(false))
  }, [])

  return (
    <AppLayout pageTitle="Posteringer">
      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#0f172a' }}>Posteringer</div>
        <div style={{ fontSize: 13, color: '#64748b' }}>Alle bogføringsposteringer fra opkrævninger, betalinger og indflytninger.</div>
      </div>
      <div style={{ background: '#fff', border: '1px solid #e8eaed', borderRadius: 10, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              <th style={th}>Dato</th>
              <th style={th}>Konto</th>
              <th style={th}>Beskrivelse</th>
              <th style={th}>Bilag</th>
              <th style={th}>Lejemål</th>
              <th style={{ ...th, ...num }}>Debet</th>
              <th style={{ ...th, ...num }}>Kredit</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td style={td} colSpan={7}>Henter…</td></tr>}
            {!loading && entries.map((e) => (
              <tr key={e.id}>
                <td style={td}>{e.entry_date}</td>
                <td style={td}><span style={{ fontFamily: 'monospace', fontWeight: 600 }}>{e.account_no}</span> {e.account_name}</td>
                <td style={{ ...td, color: '#6b7280' }}>{e.description ?? '—'}</td>
                <td style={td}>{e.invoice_number ?? '—'}</td>
                <td style={td}>{e.afdeling ?? '—'}</td>
                <td style={{ ...td, ...num }}>{kr(e.debit_oere)}</td>
                <td style={{ ...td, ...num }}>{kr(e.credit_oere)}</td>
              </tr>
            ))}
            {!loading && entries.length === 0 && (
              <tr><td style={{ ...td, color: '#9ca3af' }} colSpan={7}>Ingen posteringer endnu. De dannes når der opkræves eller registreres betaling.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AppLayout>
  )
}
